import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ErrorMessage } from "../../components/Shared/Messages/ErrorMessage";
import {
  LAST_TIME_DATE_WAS_CHECKED,
  clientTime,
  timeZone
} from "../../config/constants";
import clockIsSEt from "../../helpers/clockIsSet";
import { getTimeFromOnline } from "../../helpers/getTimeFromOnline";
import { getFromLocal, saveToLocal } from "../../helpers/handleLocalStorage";

export const useHandleDateTime = () => {
  const [onFinish, setOnFinish] = useState(false);
  const [clock, setClock] = useState({
    setClockNotification: false,
    date: ""
  });

  const lastTimeChecked = getFromLocal(LAST_TIME_DATE_WAS_CHECKED);
  const pastHoursSinceChecked = dayjs().diff(lastTimeChecked, "hours");
  const onDevEnv =
    process.env.NODE_ENV === "development" ||
    window?.location?.href?.includes("dev-portal");

  const updateState = () => {
    getTimeFromOnline(timeZone).then((res) => {
      if (res?.date_time_ymd) {
        const { isTimeAccurate } = clockIsSEt({
          clientTime,
          onlineTime: res?.date_time_ymd
        });

        // Save it to local if time is accurate
        isTimeAccurate &&
          saveToLocal({ name: LAST_TIME_DATE_WAS_CHECKED, value: dayjs() });

        setOnFinish(true);
        setClock({
          date: res?.date_time_ymd,
          setClockNotification: !isTimeAccurate
        });
      } else {
        setOnFinish(true);
        ErrorMessage(
          "We can't fetch accurate time from online, please check if your date and time is accurate!"
        );
      }
    });
  };

  useEffect(() => {
    if (onDevEnv) {
      setOnFinish(true);
      return;
    }

    // Return if you have checked the time 12 hours ago
    if (pastHoursSinceChecked <= 12) {
      setOnFinish(true);
      return;
    }

    updateState();
  }, [onDevEnv, pastHoursSinceChecked]);

  return { clock, onFinish };
};
